var mod_test = require('Modules/test');
//var blk_test = require('Blocks/test/test');


// Get jQuery available as it is expected to be
jQuery(document).ready(function($) {
    window.$ = jQuery;




    /*************************************************
     Fade out cover once page ready
    *************************************************/
    $('#cover').fadeOut(900);



    

    

    // links to same page with hashes will scroll there
    //var page_load_hashtag = require('Modules/page_load_hashtag');
    //page_load_hashtag.init( '_hash', null, null );



    // mobile menu activation
	$('#header__mobile-menu').off().on('click', function(e) {
		$('body').toggleClass('menu--show');

		$('#white-out').off().on('click', function(e) {
			$('body').removeClass('menu--show');
			$('#white-out').off()
		});
	});


	// removes mobile menu and closes submenus
	var menuClose = function() {
		if ( $('body').hasClass('menu--show') ) {
			$('body').removeClass('menu--show');
			$('#white-out').off();
			$(".menu>li>.sub-menu").slideUp(450, function() {
				$(".menu>li>.sub-menu").attr("style","");
			});
        	$(".sub-menu--active").removeClass("sub-menu--active");
		}
		else {
			$(".menu>li>.sub-menu").attr("style","");
		}
        
	}


	// click action on menu items, only impacts when mobile menu active
    $(".menu-item-has-children > a").on('click', function(e) {

        // this part is to handle accordian sub menu on mobile
        if ($('#header__mobile-menu').css('display') != 'none') {
            e.preventDefault();
            $this = $(this).closest('.menu-item-has-children');

            $(".menu>li>.sub-menu").slideUp(450);
            
            if (!$this.hasClass('sub-menu--active')) {
                $this.find('> .sub-menu').slideDown(450);
                $(".sub-menu--active").removeClass("sub-menu--active");
                $this.addClass('sub-menu--active'); 
            }
            else $(".sub-menu--active").removeClass("sub-menu--active");
        }   
    });




    // links to same page with hashes will scroll there
    var link_scroll = require('Modules/link_scroll_animate');
    link_scroll.init( '_hash', '.menu', menuClose, null );

    

    // resize listener
    $(window).resize(function() {
      var wWidth = $( window ).width();
      if (wWidth >= 1024) {
        // mobile menu clean up
        menuClose();
        console.log('remove mobile menu');
      }
    });



    // check to see if current page has page_init and then if so fires it.
    if (typeof page_init == 'function') { 
      page_init(); 
    }

    // tell content blocks it's go time
    $(document).trigger('block_init');




    /*************************************************
     find images that need to fill div 
     based on class and adjust them
    *************************************************/
    (function($){
        var resizeTimeout;

        var image_fill = function() {
            $('.imgfill').each(function(){
                var $this = $(this);

                // clear classes on img
                $this.find('img').removeClass('imgfill--x').removeClass('imgfill--y');

                // check aspect ratio and apply appropriate stretch
                var fillmeval = $this.width() / $this.height();
                var imgval = $this.find('img')[0].naturalWidth / $this.find('img')[0].naturalHeight
                var imgClass = (imgval >= fillmeval) ? "imgfill--y" : "imgfill--x";
                $this.find('img').addClass(imgClass);
            });
        }
        
        // listen for window resize and then update if needed
        $(window).on('resize', function() { 
            clearTimeout(resizeTimeout);
            resizeTimeout = setTimeout(image_fill, 150);
            image_fill(); 
        });
        $(window).on('focus', image_fill);

        // public access to force update
        window.imgfill_update = image_fill;

        // initial fire
        image_fill();
    })($);


    /*************************************************
     Update images being javascript modified
    *************************************************/
    var x = 0;
    var intervalID = setInterval(function () {
       imgfill_update();
       if (++x === 10) {
           window.clearInterval(intervalID);
       }
    }, 500);

    //setTimeout( imgfill_update, 800);
    //setTimeout( imgfill_update, 1500);


});






// When DOM is loaded initialize blocks
document.addEventListener("DOMContentLoaded", function() {
  //blk_test.init();
});


//mod_test.init();







//////////////////
// WEBPACK FOOTER
// ..-src/javascript/main.js
// module id = 0
// module chunks = 0